/* eslint-disable react/prop-types */
/* eslint-disable react/forbid-prop-types */
import 'url-search-params-polyfill';

import React, { useState, useEffect } from 'react';
// import NumberFormat from 'react-number-format';

// useState

// import PropTypes from 'prop-types';

import { Table, Input, InputNumber, Popconfirm, Form, Button } from 'antd';

import './pricingTab.scss';

const EditableCell = ({
  editing,
  dataIndex,
  title,
  inputType,
  record,
  index,
  children,
  ...restProps
}) => {
  const inputNode = inputType === 'number' ? <InputNumber /> : <Input />;
  return (
    <td {...restProps}>
      {editing ? (
        <Form.Item
          name={dataIndex}
          style={{
            margin: 0,
          }}
          rules={[
            {
              required: true,
              message: `Please Input ${title}!`,
            },
          ]}
        >
          {inputNode}
        </Form.Item>
      ) : (
        children
      )}
    </td>
  );
};

const Header = props => {
  console.log(props.values);
  const [form] = Form.useForm();
  const [data, setData] = useState([...props.values]);
  const [editingKey, setEditingKey] = useState('');

  useEffect(
    () => {
      setData([...props.values]);
    },
    [props.values],
  );

  const isEditing = record => record.pbRngNum === editingKey;

  const edit = record => {
    console.log(record);
    form.setFieldsValue({
      ...record,
    });
    setEditingKey(record.pbRngNum);
  };

  const cancel = () => {
    setEditingKey('');
  };

  const save = async (key, record) => {
    try {
      const row = await form.validateFields();
      const priceBreaks = [...data];
      const index = priceBreaks.findIndex(item => key === item.pbRngNum);
      console.log(index);
      if (index > -1) {
        const item = priceBreaks[index];
        priceBreaks.splice(index, 1, { ...item, ...row });
        setData(priceBreaks);
        setEditingKey('');
      } else {
        priceBreaks.push(row);

        setData(priceBreaks);
        setEditingKey('');
      }
      props.changeValues(record.nsnOrPn, priceBreaks[index], key);
    } catch (errInfo) {
      console.log('Validate Failed:', errInfo);
    }
  };

  const columns = [
    {
      title: 'Range',
      dataIndex: 'pbRngNum',
      key: 'pbRngNum',
    },

    {
      title: 'Upper Quantity',
      dataIndex: 'upperQty',
      key: 'upperQty',
      editable: true,
    },
    {
      title: 'Lower Quantity',
      dataIndex: 'lowerQty',
      key: 'lowerQty',
      editable: true,
    },
    {
      title: 'Unit Price',
      dataIndex: 'unitPrc',
      key: 'unitPrc',
      editable: true,
    },

    {
      title: 'operation',
      dataIndex: 'operation',
      render: (_, record) => {
        const editable = isEditing(record);
        return editable ? (
          <span>
            <Button
              type="link"
              onClick={() => save(record.pbRngNum, record)}
              style={{
                marginRight: 8,
              }}
            >
              Save
            </Button>
            <Popconfirm title="Are You Sure?" onConfirm={cancel}>
              <Button type="link">Cancel</Button>
            </Popconfirm>
          </span>
        ) : (
          <Button
            type="link"
            disabled={editingKey !== ''}
            onClick={() => edit(record)}
          >
            Edit
          </Button>
        );
      },
    },
  ];
  const mergedColumns = columns.map(col => {
    if (!col.editable) {
      return col;
    }

    return {
      ...col,
      onCell: record => ({
        record,
        inputType: 'number',
        dataIndex: col.dataIndex,
        title: col.title,
        editing: isEditing(record),
      }),
    };
  });
  return (
    <div>
      <div>
        {console.log(data)}
        <Form form={form} component={false}>
          <Table
            pagination={{
              onChange: cancel,
              hideOnSinglePage: true,
            }}
            components={{
              body: {
                cell: EditableCell,
              },
            }}
            bordered
            dataSource={data}
            columns={mergedColumns}
            rowClassName="editable-row"
          />
        </Form>
      </div>
    </div>
  );
};

export default Header;



// WEBPACK FOOTER //
// ./src/components/DibbsTabs/priceBreakTab.jsx